import { render, staticRenderFns } from "./ExpenseSelect.vue?vue&type=template&id=dd6a1b9a&"
import script from "./ExpenseSelect.vue?vue&type=script&lang=js&"
export * from "./ExpenseSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports